export const texts = {
  pageTitle: 'Knowledge database',
  pageTitleFor: (name?: string) => (name === undefined ? 'Knowledge database' : `Knowledge database - ${name}`),
  databases: {
    internalQa: { name: 'Internal Q&A', description: 'Customer questions and answers.' },
    systemAndWorkflows: { name: 'Systems and workflows', description: 'Guides and instructions for systems and work processes.' },
    escalation: { name: 'Escalation', description: 'Articles for the Escalation team.' },
    aftercare: { name: 'Aftercare', description: 'Articles for the Aftercare team.' },
    tomorrowland: { name: 'Tomorrowland', description: 'Articles for the Tomorrowland team.' },
  },
  loading: 'Loading ...',
  error: 'Something went wrong while loading the categories.',
  errorRefreshToken: 'Your session could not be refreshed. Please reload the page.',
  errorMissingTenant: 'No knowledge database was specified.',
  noCategories: 'There are no categories to display.',
  errorSubcategories: 'Something went wrong while loading the subcategories.',
  noSubcategories: 'There are no subcategories to display.',
  expandCategory: 'Show subcategories',
  collapseCategory: 'Hide subcategories',
  searchPlaceholder: 'Search the knowledge database...',
  searchResultsPageTitle: 'Search results',
  resultsCount: (count: number, query: string) =>
    count === 1 ? `1 result for "${query}"` : `${count} results for "${query}"`,
  resultsCountLimited: (limit: number, query: string) =>
    `Showing the first ${limit} results for "${query}"`,
  resultsLimitNote: (limit: number) =>
    `Only the first ${limit} matches are shown. Refine your search to narrow the results.`,
  noSearchResults: 'No results found for your search.',
  errorSearchResults: 'Something went wrong while loading the search results.',
  searchErrorMessage: 'Something went wrong while searching.',
  showMore: 'Show more',
  showLess: 'Show less',
  errorSubfolders: 'Something went wrong while loading the sub-folders.',
  errorQuestions: 'Something went wrong while loading the questions.',
  noQuestions: 'There are no questions to display.',
  goBack: 'Go Back',
  home: 'Home',
  questionErrorLoading: 'Something went wrong while loading the question.',
  questionNotFound: 'The requested question could not be found.',
  answerNotAvailable: 'No answer has been provided for this question yet.',
  errorInvalidRequest: 'The request sent is invalid. Please verify the data and try again',
}
